<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :allowFields="$lang.endedSearchCenterExecute"
      :url="url"
      :title="$lang.endedCenterExecute"
      :remove_item="removeItem"
      config="center_execute"
      :toggleable="true"
      :allowRemove="false"
      add-modal-size="lg"
      remove-modal-size="xl"
      ref="search_center_execute"
      :primaryKey="`center_execute_id`"
      :allowEdit="false"
      :isLoading="isLoading"
      :dynamicButtons="availableButtons"
      :hiddenFields="hiddenFields"
      :visibleAdd="false"
      :extraButtons="extraButtons"
      :showCheckBox="true"
      :handleCheckBoxCondition="() => true"
      @rowSelected="rowSelected"
      @rowAllItems="rowAllItems"
    >
      <template slot="addModal" slot-scope="search">
        <AddCenterExecute
          isModal
          @getData="getData"
          @modal-end-up="search.close"
        />
      </template>
    </Search>
    <b-modal
      size="xl"
      hide-header
      v-model="calendarModal"
      :ok-title="$lang.submitButton"
    >
      <DragTable
        :url="center_execute_plan_url"
        :title="$lang.execute_plan"
        ref="center_execute_plan"
        keyLang="center_execute_plan"
        :hasMoving="false"
        :editRoute="false"
        :removeLabel="$lang.exercise_remove"
        :filterCatch="true"
        :emptyText="$lang.notExistParvandehInfoMessage"
      />
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="calendarModal = false">
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </template>
    </b-modal>
    <Confirm
      :title="modalTitle"
      :description="message"
      v-model="changeModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="ok"
      @cancel="cancel"
    />
    <b-modal
      no-close-on-backdrop
      v-model="changeStatusModal"
      size="sm"
      hide-header
      hide-footer
    >
      <b-card>
        <div slot="header">
          <b v-text="$lang.change_level" />
        </div>
        <LoadingSpinner
          :loading="changeStatusLoading"
          :text="$lang.sending_data"
        />
        <b-row v-show="!changeStatusLoading">
          <b-col cols="12" md="12">
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="`${$lang.level_label}: `"
                :rules="$v.statusSelected.$params"
              />
              <selectFind
                :options="statusOptions"
                v-model="$v.statusSelected.$model"
                label="caption"
                id="id"
                :isValid="
                  $v.statusSelected.$dirty ? !$v.statusSelected.$error : null
                "
              />
              <b-form-invalid-feedback
                :state="
                  $v.statusSelected.$dirty ? !$v.statusSelected.$error : null
                "
              >
                <div v-if="!$v.statusSelected.required">
                  {{ $lang.error_required | replace($lang.level_label) }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12" class="text-right">
            <b-button
              class="mr-2"
              variant="outline-danger"
              @click="closeChangeStatusModal"
            >
              <mdicon name="close" size="20" />
              {{ $lang.close }}
            </b-button>
            <b-button variant="success" @click="changeStatus">
              <mdicon name="check" size="20" />
              {{ $lang.submitButton }}
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
    <Confirm
      v-model="checkedConfirmData.show"
      :title="$lang.center_execute_score_excel"
      :description="$lang.are_you_sure_center_execute_score_excel"
      :loading="checkedConfirmData.loading"
      :loadingSpinnerText="$lang.updating_data"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      headerVariant="success"
      dynamicClass=""
      @ok="getCenterExecuteScoreExcel"
      @cancel="closeCheckedConfirmData"
    />
    <Confirm
      v-model="rebuildAllReportsConfirmData.show"
      :title="$lang.kanoon_rebuild_all_reports"
      :description="$lang.are_you_sure_kanoon_rebuild_all_reports"
      :loading="rebuildAllReportsConfirmData.loading"
      :loadingSpinnerText="$lang.updating_data"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      headerVariant="success"
      dynamicClass=""
      @ok="patchRebuildAllReports"
      @cancel="closeRebuildAllReportsConfirmData"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddCenterExecute from "./addCenter_execute";
import Confirm from "@/components/base/confirm";
import DragTable from "@/components/base/dragTable";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import {
  generateApiUrl,
  generateError,
  generateLang,
  generateQueryStringWithKeysRepeat,
  goToRoute,
  renderEumOptions,
  storeDispatcher,
} from "@/shared/utils";
import { getAllCenterExecutePerson } from "../../services";

export default {
  components: {
    Search,
    AddCenterExecute,
    DragTable,
    Confirm,
    LoadingSpinner,
  },
  validations: {
    statusSelected: { required },
  },
  data() {
    return {
      hiddenFields: [
        "template.id",
        "template.caption",
        "assessment_plan.id",
        "company.caption",
        "assessment_plan.id",
        "assessment_plan.name",
        "created_by",
        "created_at.jalali",
      ],
      changeModal: false,
      isLoading: false,
      calendarModal: false,
      buttons: [
        {
          id: 1,
          name: "justShow",
          click: this.searchCenterExecute,
        },
        {
          name: "changeStatus",
          click: this.showChangeStatusModal,
          text: this.$lang.change_level,
          allowExecuteRoles: [3, null],
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: 11,
          name: "calendar",
          iconFont: "fa fa-list-ol fa-lg text-warning ",
          click: this.centerExecuteCalendar,
        },
        {
          id: 4,
          name: "visitCases", //مشاهده پرونده‌ها
          iconFont: "fas fa-folder-open fa-lg text-info ",
          click: this.searchCase,
        },
        {
          id: 7,
          name: "washup",
          click: this.showWashUp,
          allowExecuteRoles: [7, null],
        },
        {
          id: 9,
          name: "excelExport",
          click: this.export_excel,
        },
        {
          id: 10,
          name: "editView",
          text: this.$lang.show_in_dashboard,
          iconFont: {
            name: "chart-box-outline",
            size: "24",
            class: "text-primary",
          },
          click: this.getCenterExecutePerson,
        },
      ],
      mode: "",
      modalTitle: "",
      message: "",
      changingItems: null,
      removingItem: null,
      centerExecutePlanId: null,
      centerExecuteId: null,
      statusSelected: null,
      changeStatusModal: false,
      changeStatusLoading: false,
      checkedItems: [],
      checkedConfirmData: {
        show: false,
        loading: false,
      },
      rebuildAllReportsConfirmData: {
        show: false,
        loading: false,
      },
    };
  },
  computed: {
    url() {
      return generateApiUrl(["kanoon", "ended_center_execute"]);
    },
    center_execute_plan_url() {
      return generateApiUrl(
        ["kanoon", "center_execute_plan_id"],
        [this.centerExecutePlanId]
      );
    },
    statusOptions() {
      return renderEumOptions("center_execute_status").map((item) => {
        return {
          caption: pathOr("", ["text"], item),
          id: pathOr("", ["value"], item),
        };
      });
    },
    extraButtons() {
      return [
        {
          name: "editView",
          condition: !!this.checkedItems.length,
          title: this.$lang.center_execute_score_excel,
          click: this.showCheckedConfirmData,
          iconName: "shield-check-outline",
        },
        {
          name: "editView",
          condition: true,
          title: this.$lang.kanoon_rebuild_all_reports,
          click: this.showRebuildAllReportsConfirmData,
          iconName: "file-sync-outline",
        },
      ];
    },
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    goToRoute,
    renderEumOptions,
    getData() {
      this.$refs.search_center_execute.getItems();
    },
    centerExecuteCalendar(item) {
      this.centerExecutePlanId = pathOr(null, ["center_execute_id"], item);
      this.calendarModal = true;
    },
    clearModal() {
      this.mode = "";
      this.changeModal = false;
      this.modalTitle = "";
    },
    ok() {
      if (this.mode == "change_status") {
        this.confirmedChangeStatus();
      } else if (this.mode == "remove_item") {
        this.confirmedRemoveItem();
      }
      this.clearModal();
    },
    cancel() {
      if (this.mode == "change_status") {
        this.notConfirmedChangeStatus();
      } else if (this.mode == "remove_item") {
        this.notConfirmedRemoveItem();
      }
      this.clearModal();
    },
    availableButtons(item) {
      if (!item || !("status_object" in item)) return [];
      return this.buttons.filter((button) => {
        const itemExecuteRole = pathOr(null, ["executive_role", "id"], item);
        const allowExecuteRoles = pathOr([], ["allowExecuteRoles"], button);
        return allowExecuteRoles.length
          ? includes(itemExecuteRole, allowExecuteRoles)
          : true;
      });
    },
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
        // this.handleBack();
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    searchCenterExecute(item) {
      const centerExecuteCaption = pathOr("", ["caption"], item);
      const title = `${generateLang([
        "centerExecuteEdit",
      ])} <span class="margin-right-4">${centerExecuteCaption}</span>`;
      storeDispatcher("mobileHeaderTitleText", title);
      storeDispatcher("mobileHeaderBaseRoute", this.$route.name);
      const centerExecuteId = pathOr(null, ["center_execute_id"], item);
      const params = { centerExecuteId };
      goToRoute("center-execute-edit", params, {}, false);
    },
    searchCase(item) {
      const name = "center-execute-cases";
      const centerExecuteId = pathOr(null, ["center_execute_id"], item);
      const params = { centerExecuteId };
      goToRoute(name, params, {}, false);
    },
    showWashUp(item) {
      const name = "list-washup";
      const centerExecuteId = pathOr(null, ["center_execute_id"], item);
      const params = { centerExecuteId };
      goToRoute(name, params, {}, false);
    },
    editItem(item) {},
    confirmedRemoveItem() {
      if (this.removingItem) {
        this.isLoading = true;
        return this.$httpService
          .delete(this.url + "/" + this.removingItem.center_execute_id)
          .then((response) => {
            this.$notify.success(response.data.message);
            return true;
          })
          .catch((err) => {
            this.$notify.error(err.response.data.message);
            throw "error";
          })
          .finally(() => {
            this.isLoading = false;
            this.removingItem = null;
            this.message = "";
            this.$refs.search_center_execute.getItems();
          });
      }
    },
    notConfirmedRemoveItem() {
      this.removingItem = null;
      this.message = "";
    },
    removeItem(item) {
      this.removingItem = item;
      this.mode = "remove_item";
      this.message = this.$lang.are_you_sure;
      this.modalTitle = this.$lang.remove_item;
      this.changeModal = true;
    },
    toggle_item(item) {},
    confirmedChangeStatus() {
      if (this.changingItems != null && this.status != null) {
        this.isLoading = true;
        let payLoad = {
          status: this.status,
        };
        this.isLoading = true;
        return this.$httpService
          .patch(
            this.$config.api_url +
              this.$config.kanoon.center_execute +
              "/" +
              this.changingItems.center_execute_id +
              "/state",
            payLoad
          )
          .then((response) => {
            this.$notify.success(response.data.message);
            this.$refs.search_center_execute.getItems();
            return true;
          })
          .catch((error) => {
            this.$generateError(error);
          })
          .finally(() => {
            this.isLoading = false;
            this.changingItems = null;
            this.status = null;
            this.message = "";
            this.$refs.search_center_execute.getItems();
          });
      }
    },
    notConfirmedChangeStatus() {
      this.changingItems = null;
      this.status = null;
      this.message = "";
    },
    async export_excel(item) {
      try {
        this.isLoading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_export"],
          [item.center_execute_id]
        );
        const response = await this.$httpService.get(url);
        const fileURL = response.data.data;
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;

        fileLink.setAttribute("download", "");
        fileLink.click();
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    showChangeStatusModal(item) {
      this.centerExecuteId = pathOr(null, ["center_execute_id"], item);
      this.statusSelected = pathOr(null, ["status"], item);
      this.changeStatusModal = true;
    },
    closeChangeStatusModal() {
      this.centerExecuteId = null;
      this.statusSelected = null;
      this.changeStatusModal = false;
    },
    async changeStatus() {
      try {
        this.changeStatusLoading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_state"],
          [this.centerExecuteId]
        );
        const payload = {
          status: pathOr(null, ["id"], this.statusSelected),
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.closeChangeStatusModal();
        this.$refs.search_center_execute.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.changeStatusLoading = false;
      }
    },
    rowSelected(item, callback) {
      const alreadyExist = this.checkedItems.some(
        (x) => x == item.center_execute_code
      );
      if (alreadyExist) {
        this.checkedItems = this.checkedItems.filter((x) => {
          return x !== item.center_execute_code;
        });
        return;
      }

      this.checkedItems.push(item.center_execute_code);
    },
    rowAllItems(items) {
      this.checkedItems = items
        .filter((item) => item.selected)
        .map((item) => item.center_execute_code);
    },
    showCheckedConfirmData() {
      this.checkedConfirmData.show = true;
    },
    closeCheckedConfirmData() {
      this.checkedConfirmData.show = false;
    },
    async getCenterExecuteScoreExcel() {
      try {
        this.checkedConfirmData.loading = true;
        const queryString = generateQueryStringWithKeysRepeat(
          this.checkedItems,
          "center_execute_code"
        );

        const url =
          generateApiUrl(["kanoon", "center_execute_score_excel"]) +
          queryString;
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        this.$notify.success(response.data.message);
        this.closeCheckedConfirmData();
        window.open(data, "_blank");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.checkedConfirmData.loading = false;
      }
    },
    showRebuildAllReportsConfirmData() {
      this.rebuildAllReportsConfirmData.show = true;
    },
    closeRebuildAllReportsConfirmData() {
      this.rebuildAllReportsConfirmData.show = false;
    },
    async patchRebuildAllReports() {
      try {
        this.rebuildAllReportsConfirmData.loading = true;
        const url = generateApiUrl(["kanoon", "kanoon_rebuild_all_reports"]);
        const response = await this.$httpService.patch(url);
        this.$notify.success(response.data.message);
        this.closeRebuildAllReportsConfirmData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.rebuildAllReportsConfirmData.loading = false;
      }
    },
    goToReportDashboard(items) {
      const data = items.map((item) => {
        return {
          code: pathOr(null, ["parvandeh", "code"], item),
          parvandehNumber: pathOr(
            null,
            ["parvandeh", "parvandeh_number"],
            item
          ),
          fullName: pathOr(null, ["parvandeh", "person", "name"], item),
          image: pathOr("", ["parvandeh", "image_address"], item),
          termCaption: pathOr("", ["parvandeh", "term_caption"], item),
        };
      });
      localStorage.setItem("dashboard-parvandeh-codes", JSON.stringify(data));
      goToRoute("report_dashboard", {}, {}, false);
    },
    async getCenterExecutePerson(item) {
      const id = pathOr(null, ["center_execute_id"], item);
      try {
        this.isLoading = true;
        const page = 1;
        const perPage = 50;
        const response = await getAllCenterExecutePerson(id, page, perPage);
        const { items } = response;
        const persons = items.filter((person) => {
          const isCandidate =
            pathOr(null, ["executive_role", "id"], person) === 1;
          const isPresent = pathOr(null, ["is_absent", "id"], person) === 0;
          return isCandidate && isPresent;
        });
        this.goToReportDashboard(persons);
      } catch (error) {
        generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
